/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import DentalSurfaceErosion from './dental-surface-erosion';
import DentalSurfaceErosionDetail from './dental-surface-erosion-detail';
import DentalSurfaceErosionUpdate from './dental-surface-erosion-update';
import DentalSurfaceErosionDeleteDialog from './dental-surface-erosion-delete-dialog';

const DentalSurfaceErosionRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<DentalSurfaceErosion />} />
    <Route path="new" element={<DentalSurfaceErosionUpdate />} />
    <Route path=":id">
      <Route index element={<DentalSurfaceErosionDetail />} />
      <Route path="edit" element={<DentalSurfaceErosionUpdate />} />
      <Route path="delete" element={<DentalSurfaceErosionDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default DentalSurfaceErosionRoutes;
